import React from "react";
import * as ReactDOM from "react-dom";
import { Button, Modal, Toast, ListView, Icon } from "antd-mobile";
import { href } from "../../utils/util";

import "./index.less";

class WithdrawalRecordsList extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {
            urlOps: {},
        };
    }

    componentDidMount() {
        // var obj = '',obj1 = '',ops={};
        // if(window.location.hash.indexOf('?') > -1 ){
        //     obj = window.location.hash.split('?')[1];
        //     obj1 = obj.split('&');
        //     for(var i=0;i<obj1.length;i++){
        //         ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
        //     }
        //     if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
        //         Toast.fail('请登录APP再进行操作',999);
        //         return;
        //     }
        //     this.setState({
        //         urlOps: ops
        //     },()=>{
        //     });
        // }
    }

    render() {
        // const {data, urlOps, activityResult, sharkNum, canWithdrawalCash} = this.state;

        return (
            <div className="peaceSharkShareBox">
                <div className="main-bg">
                    <div className="top-logo">
                        <div className="top-logo-left"></div>
                        <div className="top-logo-right"></div>
                    </div>
                    <div className="car-left"></div>
                    <div className="car-right"></div>
                    <div className="decorate-left"></div>
                    <div className="decorate-right"></div>
                </div>
                <div className="button-content">
                    <div
                        className="shark-button"
                        onClick={() => {
                            window.location.href =
                                "https://www.hellogil.com/appDownload/#/HuilianDownload";
                        }}
                    ></div>
                </div>

                <div
                    className="activity"
                    style={{ paddingTop: "0.01rem" }}
                >
                    <div className="activity-box">
                        <div className="activity-logo">
                            <div className="activity-logo-left"></div>
                            <div className="activity-logo-title">活动说明</div>
                            <div className="activity-logo-right"></div>
                        </div>
                        <div className="content">
                            <p>
                                1、一期活动时间：2022年11月1日-2023年1月31日，排行榜话费奖励及百日挑战抽奖均属一期奖励；二期活动时间：2023年2月1日起。
                            </p>
                            <p>
                                2、自活动开始之日起，每天都可摇一摇领取平安金激励，并且每人每天最多有3次摇红包机会哦。
                            </p>
                            <p>
                                3、摇一摇获得的平安金奖励到账需完成一定的挑战任务，如简短的安全视频学习、车辆绑车、邀好友参与等。于“中奖记录”中可查看到账情况及补充完成任务。
                            </p>
                            <p>
                                4、一旦发生违章或出险记录，则必须完成安全通关考试，否则无法继续参与摇奖。
                            </p>
                            <p>
                                5、用户获得的平安金奖励，可直接提现到充电账户或现金账户。其中提现到充电账户的额度比直接提现到个人账户将多10%额度上浮，提现到银行卡需满5元方可提现。
                            </p>
                            <p>
                                6、以上所有“慧联车辆司机”，皆指远程慧联在租车辆当前被授权/绑车司机。所有慧联车辆司机须提前完成慧联车辆关联，方法一：被运营商在APP内完成车辆授权；方法二：点击“我的-我的绑定车辆”，可进行慧联车辆的自主绑定。
                            </p>
                            <p>
                                7、同一手机号、同一账号、同一设备，满足任一条件均视为同一用户。针对非正常手段刷单抽奖的，主办方有权追究其法律责任及追回相关损失。
                            </p>
                            <p>
                                8、为保证正常参与活动，请将“远程慧联”APP升级至最新版本。
                            </p>
                            <p>
                                9、本次活动最终解释权归主办方所有，与苹果（Apple
                                Inc）无关。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default WithdrawalRecordsList;



// WEBPACK FOOTER //
// ./src/peaceSharkIndex/share/index.js